// extracted by mini-css-extract-plugin
export var displayNone = "_nc-6";
export var imgContainer = "_nc-2";
export var overflowHidden = "_nc-3";
export var productInfoCardButtonContainer = "_nc-5";
export var productTitleText = "_nc-4";
export var rightArrow = "_nc-1";
export var rightArrowContainer = "_nc-0";